module.exports = __webpack_public_path__ + "static/media/undraw_server_down_s4lk.a2651e07.svg";